import { ref } from 'vue';
import { isPrivyCustodialLogin } from '@/utils/privy';
import { isPrivyDepositRequiredError } from '@/utils/privy-platform-login';
import { openGlobalDepositDialog } from '@/utils/analytics-deposit-trigger';
import { isFirstDepositUser } from '@/utils/deposit-real-credit';

/** App 壳：邮箱/Google 新用户下单前「充值 $1 激活体验金」弹窗 */
export const trialActivateDepositPromptOpen = ref(false);

/** 仅打开提示（不阻塞 await） */
export function openTrialActivateDepositPrompt() {
  trialActivateDepositPromptOpen.value = true;
}

export function dismissTrialActivateDepositPrompt() {
  trialActivateDepositPromptOpen.value = false;
}

/** 确认 → 关弹窗并打开充值 */
export async function confirmTrialActivateDepositPrompt() {
  trialActivateDepositPromptOpen.value = false;
  await openGlobalDepositDialog({ trigger: 'trial_fund_claim' });
}

/**
 * 邮箱/Google 托管且仍是首次充值用户（无 CREDITED、入账 USD≥0.1）时拦截。
 * 不以 wallet/balances、activityDusd、points 为准；接口未知时放行，由 818 兜底。
 * @param {{ simulateOnly?: boolean }} [opts]
 * @returns {Promise<boolean>} true 可继续下单
 */
export async function guardTradeAgainstTrialActivateDeposit(opts = {}) {
  if (opts.simulateOnly) return true;
  if (!isPrivyCustodialLogin()) return true;

  let first = null;
  try {
    first = await isFirstDepositUser();
  } catch (err) {
    console.warn('[trial-activate-deposit] credit scan failed', err);
    return true;
  }
  if (first !== true) return true;

  openTrialActivateDepositPrompt();
  return false;
}

/**
 * 下单失败：818 / PRIVY_DEPOSIT_REQUIRED → 同款弹窗。
 * @returns {boolean} 是否已接管（调用方勿再自动跳充值）
 */
export function maybePromptTrialActivateDepositFromError(err) {
  if (!isPrivyDepositRequiredError(err)) return false;
  openTrialActivateDepositPrompt();
  return true;
}
